import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentyear: number = new Date().getFullYear();
  constructor() { }

  currentDate = new Date();

  baseCounter = 4085; // Counter fetched from hitwebcounter
  additionalCount = 100000; // Manually added
  displayedVisitorCount = 0;

  ngOnInit(): void {
    this.displayedVisitorCount = this.baseCounter + this.additionalCount;
  }


}
